var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 71,
    viewBox: "0 0 30 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6558 70.6433H18.0041C16.846 70.209 15.9576 69.6497 15.4114 68.4849C15.3259 68.3007 14.9837 67.3728 14.9837 67.261V43.5318C14.7205 43.2094 14.1282 43.2225 13.8848 43.5318V67.1228C13.8848 67.6821 13.2991 68.7547 12.924 69.1956C10.838 71.6765 6.77129 70.5578 6.21854 67.3662L6.11325 26.3634C5.58681 25.6856 4.98799 26.0936 4.94193 26.8438L4.8827 44.1635C3.92195 46.6575 0.934425 46.3614 0 44.0188V22.0861C0.56592 19.1183 2.78353 16.9402 5.83687 16.7033C11.4368 16.2624 17.6159 17.0257 23.2817 16.723C26.3613 17.0981 28.6118 19.4671 28.8685 22.5665C28.4868 29.3114 29.362 36.5894 28.8685 43.2686C28.6447 46.289 25.1242 46.9339 23.9726 44.1701L23.9134 26.8438C23.8673 25.9422 23.0119 25.6725 22.6763 26.574V67.2675C22.4262 68.9785 21.222 70.1103 19.6493 70.6433H19.6558Z",
    fill: "#234A30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4299 13.9769C18.275 13.9769 21.392 10.8481 21.392 6.98845C21.392 3.12884 18.275 0 14.4299 0C10.5848 0 7.46777 3.12884 7.46777 6.98845C7.46777 10.8481 10.5848 13.9769 14.4299 13.9769Z",
    fill: "#234A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ced3c2e00a3c276229b408397c653494.svg";
export { ForwardRef as ReactComponent };